import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Select, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminHeaderComp from "../subComponent/AdminHeaderComp";
import { headCellStyle } from "../data/styles";
import "../data/styles.css";
import { doc, getDocs, setDoc, collection, updateDoc, query, orderBy } from "firebase/firestore";
import { db } from "../services/firebase";

const NfcUsers = () => {
    const navigate = useNavigate();
    const [usersData, setUsersData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
        if (!localStorage.getItem("invCreator")) {
            navigate("/login-creator");
        }
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const usersCollection = collection(db, "users");
            const querySnapshot = await getDocs(usersCollection);

            const fetchedUsers = querySnapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            })).sort((a, b) => {
                // Sort by createdAt in descending order
                const dateA = new Date(Number(a.createdAt));
                const dateB = new Date(Number(b.createdAt));
                return dateB - dateA;
            });
            setUsersData(fetchedUsers);
        } catch (error) {
            console.error("Error fetching Users:", error);
        }
    };

    const togglePaymentStatus = async (userId, currentStatus) => {
        try {
            const newStatus = currentStatus === "Successful" ? "Pending" : "Successful";
            await updateDoc(doc(db, "users", userId), { paymentStatus: newStatus });

            // Update local state
            setUsersData((prevData) =>
                prevData.map((user) =>
                    user.id === userId ? { ...user, paymentStatus: newStatus } : user
                )
            );
        } catch (error) {
            console.error("Error updating payment status:", error);
        }
    };

    const handlePaymentStatusChange = async (userId, newStatus) => {
        try {
            await updateDoc(doc(db, "users", userId), { paymentStatus: newStatus });

            // Update local state
            setUsersData((prevData) =>
                prevData.map((user) =>
                    user.id === userId ? { ...user, paymentStatus: newStatus } : user
                )
            );
        } catch (error) {
            console.error("Error updating payment status:", error);
        }
    };

    const formatDate = (timestamp) => {
        const date = new Date(Number(timestamp)); // Convert timestamp to number
        return `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getDate().toString().padStart(2, "0")}`;
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Box>
            <AdminHeaderComp />
            <Box
                sx={{
                    width: "100vw",
                    minHeight: "calc(100vh - 3.5rem)",
                    backgroundColor: "#0f172a",
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <TableContainer component={Paper} sx={{ width: "95%", overflowY: "scroll", height: "86vh", my: "1rem", }}>
                    <Table>
                        <TableHead sx={{ backgroundColor: "#3e8596" }}>
                            <TableRow>
                                <TableCell sx={headCellStyle}>Created At</TableCell>
                                <TableCell sx={headCellStyle}>Phone No</TableCell>
                                <TableCell sx={headCellStyle}>Name</TableCell>
                                <TableCell sx={headCellStyle}>Company Name</TableCell>
                                <TableCell sx={headCellStyle}>Price</TableCell>
                                <TableCell sx={headCellStyle}>Payment Status</TableCell>
                                <TableCell sx={headCellStyle}>Profile</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {usersData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((user, index) => (
                                <TableRow
                                    key={user.id}
                                    sx={{
                                        backgroundColor: index % 2 === 0 ? "white" : "lightgrey",
                                        "&:hover td": {
                                            color: "green",
                                        },
                                    }}
                                >
                                    <TableCell>{formatDate(user.createdAt)}</TableCell>
                                    <TableCell>{user.mobileNumber || "N.A"}</TableCell>
                                    <TableCell>
                                        {user.firstName || ""} {user.middleName || ""}{" "}
                                        {user.lastName || ""}
                                    </TableCell>
                                    <TableCell>{user.companyName || "N.A"}</TableCell>
                                    <TableCell>{user.cardPrice || "N.A"}</TableCell>
                                    <TableCell>
                                        {user.paymentStatus ? (
                                            <Button
                                                variant="contained"
                                                sx={{
                                                    backgroundColor:
                                                        user.paymentStatus === "Successful" ? "green" : "red",
                                                    color: "white",
                                                    "&:hover": {
                                                        backgroundColor:
                                                            user.paymentStatus === "Successful"
                                                                ? "darkgreen"
                                                                : "darkred",
                                                    },
                                                    minWidth: "129px",
                                                }}
                                                onClick={() =>
                                                    togglePaymentStatus(user.id, user.paymentStatus)
                                                }
                                            >
                                                {user.paymentStatus}
                                            </Button>
                                        ) : (
                                            <Select
                                                value="N.A"
                                                onChange={(e) =>
                                                    handlePaymentStatusChange(user.id, e.target.value)
                                                }
                                                sx={{ minWidth: "129px" }}
                                            >
                                                <MenuItem value="N.A">N.A</MenuItem>
                                                <MenuItem value="Successful">Activate</MenuItem>
                                            </Select>
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() =>
                                                window.open(
                                                    `https://tapxtream.com/profile/${user.uid}`,
                                                    "_blank"
                                                )
                                            }
                                        >
                                            url
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        component="div"
                        count={usersData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </Box>
        </Box>
    );
};

export default NfcUsers;